import React, {useContext} from 'react';

import {ReportsContext} from '../../Reports.context';

import AttemptFilter from './AttemptFilter';
import DateFilter from './DateFilter';
import SubjectFilter from './SubjectFilter';
import StandardSetFilter from './StandardSetFilter';
import {ResetFiltersButton} from './ResetFiltersButton';

export default function Filters() {
  const {subject, guideLevel, standardSets, start, end, attemptNumber} = useContext(ReportsContext);

  return (
    <div className='reports__metrics-filters u-display_flex u-gap_1'>
      <DateFilter key={`${start}${end}`} />
      <SubjectFilter key={`${subject || 'no-subject'}${guideLevel || 'no-guide-level'}`} />
      <StandardSetFilter key={standardSets || 'no-standard-sets'} />
      <AttemptFilter key={attemptNumber} />
      <ResetFiltersButton />
    </div>
  );
}
